module.exports = __webpack_public_path__ + "f2bdb85bd134cc80fe4ddb7886a9a8ea.svg";